"use client";

import { useTheme } from "@/lib/theme/them-provider";


export type StackProps = {
  gap?: "xs" | "sm" | "md" | "lg" | "xl";
  align?: "start" | "center";
};

export function Stack({
  gap = "md",
  align = "start",
  children,
}: React.PropsWithChildren<StackProps>) {
  const { theme } = useTheme();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing[gap],
        alignItems: align === "center" ? "center" : "flex-start",
      }}
    >
      {children}
    </div>
  );
}
